import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import { STATUS_OK } from 'apps/auth/constants/Constants';
import media from 'apps/auth/theme/media';

const IconContainer = styled.span`
    margin-right: 16px;
    display: inline-flex;

    ${media.desktop1920} {
        margin-right: 24px;
    }
`;

const getIconName = (currStatus) => {
    if (currStatus > STATUS_OK) {
        return 'cross-rounded';
    } else if (currStatus === STATUS_OK) {
        return 'check';
    } else if (currStatus < STATUS_OK) {
        return 'clock';
    }
};

const ActivityStatus = ({ status, comment = null, text = '', isShowStatus = false, isUseExternalIconName = false, externalGetIconName }) => {
    if (isShowStatus || (status !== STATUS_OK && !comment)) {
        return (
            <Row flex align="center">
                <IconContainer>
                    <Icon name={isUseExternalIconName ? externalGetIconName() : getIconName(status)} />
                </IconContainer>
                <Text>{text}</Text>
            </Row>
        );
    }
    return null;
};
ActivityStatus.propTypes = {
    isShowStatus: PropTypes.bool,
    isUseExternalIconName: PropTypes.bool,
    text: PropTypes.string,
    status: PropTypes.number,
    comment: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    externalGetIconName: PropTypes.func,
};
export default ActivityStatus;
